export type MembershipPlan = 'bronce' | 'plata' | 'oro';
export type BillingPeriod = 'mensual' | 'anual';

export interface Profile {
  user_id: string;
  nombre: string;
  telefono: string;
  modelo_celular: string;
  username?: string | null;
  pin?: string | null;
  ubicacion_tienda?: string | null;
  created_at: string;
}

export interface Membership {
  id: string;
  plan: MembershipPlan;
  billing_period: BillingPeriod;
  start_date: string;
  end_date: string;
  is_active: boolean;
  activated_at?: string | null;
  activated_by?: string | null;
}

export interface Redemption {
  id: string;
  benefit_type: string;
  quantity: number;
  month_year: string;
  notes: string | null;
  created_at: string;
  redeemed_by: string;
  redeemer_name?: string; // Populated from profiles lookup
  redeemer_ubicacion?: string | null; // Store location of the redeemer
}

export interface Payment {
  id: string;
  membership_id: string;
  user_id: string;
  amount: number;
  plan: MembershipPlan;
  billing_period: BillingPeriod;
  payment_type: 'activation' | 'renewal';
  processed_by: string;
  processor_name?: string; // Populated from profiles lookup
  notes: string | null;
  created_at: string;
}

export interface DiscountPurchase {
  id: string;
  product_name: string;
  category: string;
  original_price: number;
  discount_percentage: number;
  final_price: number;
  savings: number;
  quantity: number;
  registered_by: string;
  registrar_name?: string;
  registrar_ubicacion?: string | null; // Store location of the registrar
  notes: string | null;
  created_at: string;
  month_year: string;
}

export interface MemberData {
  profile: Profile;
  membership: Membership | null;
  redemptions: Redemption[];
  payments?: Payment[];
  discountPurchases?: DiscountPurchase[];
}

export interface BenefitInfo {
  name: string;
  max: number;
  icon: string;
}

export interface BenefitVisual {
  icon: string;
  iconBg: string;
  imageBg: string;
  description: string;
}

export type MonthlyBenefits = Record<string, BenefitInfo>;

// Pricing structure (in colones)
export const PLAN_PRICING: Record<MembershipPlan, Record<BillingPeriod, number>> = {
  bronce: {
    mensual: 12000,
    anual: 120000,
  },
  plata: {
    mensual: 27000,
    anual: 270000,
  },
  oro: {
    mensual: 45000,
    anual: 450000,
  },
};
